'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

    _this.state = { isHovering: false };
    return _this;
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var color = this.state.isHovering && this.props.hoverColor ? this.props.hoverColor : this.props.color;
      return _react2.default.createElement(
        'span',
        { onMouseOut: this.onMouseOut.bind(this), onMouseOver: this.onMouseOver.bind(this) },
        _react2.default.createElement(
          'svg',
          { viewBox: '-2 -3 18 18', width: '100%', height: '100%' },
          _react2.default.createElement('path', { d: 'M3.555 10.104c0 .369.127.639.382.81.256.17.711.26 1.368.27v1.025c-1.996-.027-2.994-.695-2.994-2.003V7.923C2.31 7.062 1.54 6.63 0 6.63V5.57c1.54 0 2.31-.43 2.31-1.292V2.003C2.31.695 3.31.027 5.306 0v1.019c-.657.009-1.112.099-1.367.27-.256.17-.383.44-.383.81v2.27c0 .943-.531 1.508-1.593 1.694v.083c1.062.186 1.593.751 1.593 1.695v2.263zm6.61-2.263c0-.944.533-1.509 1.6-1.695v-.083c-1.067-.186-1.6-.751-1.6-1.695v-2.27c0-.369-.129-.64-.386-.813-.258-.173-.712-.262-1.364-.266V0c2 .027 3.001.695 3.001 2.003v2.276c0 .862.77 1.292 2.31 1.292v1.06c-1.54 0-2.31.43-2.31 1.292v2.283c0 1.308-1 1.976-3.001 2.003v-1.025c.652-.005 1.106-.094 1.364-.267.257-.173.386-.444.386-.813V7.84z', fill: color })
        )
      );
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut() {
      this.setState({ isHovering: false });
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver() {
      this.setState({ isHovering: true });
    }
  }]);

  return _class;
}(_react.Component);

_class.propTypes = {
  color: _react.PropTypes.string.isRequired,
  hoverColor: _react.PropTypes.string
};
_class.displayName = 'Object';
exports.default = _class;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/@segment/icons/build/react/Object.js
// module id = 1083
// module chunks = 0